import gql from 'graphql-tag';

export const ReportTemplateCoreAttributes = `
id
name
reportType
shared
category
issuesFilter
accessToken
lastRunOn
includesAccessibility
includesBestPractices
includesBadLinks
includesMisspellings
includesWebGovernance
includesSeo
includesWebGovernance
includesInfoSearches
customChecks(enabled: null) {
  id
  name
  category
  successCriteriaWithGuideline {
    tag
    title
    guidelines
  }
}
accessibilityIssues {
  id
  help
  successCriteriaWithGuideline {
    tag
    title
    guidelines
  }
}
bestPracticesIssues {
  id
  help
}
seoIssues {
  id
  title
}
accountScope
selections {
  id
  site {
    id
    name
    url
  }
  group {
    id
    name
    allSites
  }
}
`;

export const ReportTemplateQuery = gql`
  query ReportTemplateQuery($reportTemplateId: String!, $accountId: String!) {
    reportTemplate(reportTemplateId: $reportTemplateId, accountId: $accountId) {
      ${ReportTemplateCoreAttributes}
    }
  }
`;

export const CreateReportTemplateMutation = gql`
  mutation CreateReportTemplate($accountId: String!, $attributes: ReportTemplateInput!) {
    createReportTemplate(accountId: $accountId, attributes: $attributes) {
      reportTemplate {
        ${ReportTemplateCoreAttributes}
      }
    }
  }
`;

export const UpdateReportTemplateMutation = gql`
  mutation UpdateReportTemplate($accountId: String!, $reportTemplateId: String!, $attributes: ReportTemplateInput!) {
    updateReportTemplate(accountId: $accountId, reportTemplateId: $reportTemplateId, attributes: $attributes) {
      reportTemplate {
        ${ReportTemplateCoreAttributes}
      }
    }
  }
`;

export const ReportTemplatesQuery = gql`
  query ReportTemplatesQuery($accountId: String!, $page: Int!, $perPage: Int!, $sortBy: ReportTemplatesSortBy!, $sortOrder: SortOrder!, $search: String, $siteId: String, $groupId: String) {
    reportTemplates(accountId: $accountId, page: $page, perPage: $perPage, sortBy: $sortBy, sortOrder: $sortOrder, search: $search, siteId: $siteId, groupId: $groupId) {
      currentPage
      perPage
      totalPages
      totalEntries
      nodes {
        ${ReportTemplateCoreAttributes}
      }
    }
  }
`;

export const DestroyReportTemplatesMutation = gql`
  mutation DestroyReportTemplates($accountId: String!, $reportTemplateIds: [String!]!) {
    destroyReportTemplates(accountId: $accountId, reportTemplateIds: $reportTemplateIds) {
      status
    }
  }
`;

export const GenerateReportMutation = gql`
  mutation GenerateReport($accountId: String!, $reportTemplateId: String!, $siteId: String, $groupId: String) {
    generateReport(accountId: $accountId, reportTemplateId: $reportTemplateId, siteId: $siteId, groupId: $groupId) {
      isQueued
      report {
        id
        date
        url
        reportTemplate {
          id
          lastRunOn
        }
      }
    }
  }
`;

export const reportTemplateStateDefaults = {
  name: '',
  reportType: "page",
  issuesFilter: "no_issues_filter",
  category: "summary",
  includesAccessibility: true,
  includesBestPractices: true,
  includesBadLinks: true,
  includesMisspellings: true,
  includesWebGovernance: true,
  includesSeo: true,
  includesInfoSearches: true,
  customChecks: [],
  accessibilityIssues: [],
  bestPracticesIssues: [],
  seoIssues: [],
  accountScope: "all_sites_and_groups",
  selections: [],
  accountIds: []
};
